import { ThemedHeader as Header } from './header';
export const ThemedHeader = Header;
